import { UserTypes } from "../modules/user/containers/types";

export const Types = {
    IHttpService: Symbol("IHttpService"),
    User: { ...UserTypes },
};